import type { ReactNode } from 'react';

import { useAnchorable } from '../../hooks/useAnchorable';

import { useCopyToClipboard } from '../../../../utils/useCopyToClipboard';

import { Icon } from '../../../../icon/Icon';
import { codeBlock, copyButton, pre, preWrapper } from './CodeBlock.css';
import type { TPostCodeBlockProps } from './CodeBlock.types';

const CopyButton = ({ code }: { code: string }) => {
  const { copied, copy } = useCopyToClipboard();

  return (
    <button
      type="button"
      className={copyButton}
      onClick={() => copy(code)}
      aria-label={copied ? 'Copied' : 'Copy code'}
    >
      <Icon name={copied ? 'check' : 'copy'} type={copied ? 'check' : 'copy'} size={16} aria-hidden />
    </button>
  );
};

export const PostCodeBlock = (
  props: TPostCodeBlockProps & {
    children?: ReactNode;
    horizontallyScrollable?: boolean;
  },
) => {
  const { element, children, horizontallyScrollable = true } = props;
  const { anchorAttributes } = useAnchorable(element?.attrs);

  const highlightedCode = element?.attrs?.data?.highlighted_code;
  const rawText = element?.content?.[0]?.text;

  return (
    <div {...anchorAttributes} className={codeBlock}>
      <div className={preWrapper}>
        {rawText ? <CopyButton code={rawText} /> : null}
        <pre className={pre({ horizontallyScrollable })}>
          {highlightedCode ? (
            <code dangerouslySetInnerHTML={{ __html: highlightedCode }} />
          ) : (
            children || <code>{rawText}</code>
          )}
        </pre>
      </div>
    </div>
  );
};
